import createSetter from "./createSetter";

export default function projectionsSlice(set) {
  return {
    setTechProgress: createSetter(set, "techProgress"),
    setInvestment: createSetter(set, "investment"),
    setYearsToCompletion: createSetter(set, "yearsToCompletion"),
  };
}
